import { translate as stateTranslate } from './ReferralStates';
import { StatesColors } from '@arredo/reactjs-ui';

export const detailColumns = [
    {
        id: 'id',
        label: 'Id'
    },
    {
        id: 'refId',
        label: 'SKU',
        sort: true
    },
    {
        id: 'name',
        label: 'Descripción'
    },
    {
        id: 'colorCode',
        label: 'Color'
    },
    {
        id: 'plannedQuantity',
        label: 'Planificada',
        align: 'right',
        sort: true
    },
    {
        id: 'quantity',
        label: 'Recibida',
        align: 'right',
        sort: true
    },
    {
        id: 'difference',
        label: 'Diferencias',
        align: 'right',
        sort: true
    }
]

export const referralColumns = [{
    field: 'id',
    header: 'Id',
    sizes: { xs: 1 }
},
{
    field: 'number',
    header: 'Nro. Envio',
    sizes: { xs: 2 }
},
{
    field: 'state',
    header: 'Estado',
    translate: (state) => stateTranslate[state],
    sx: (row) => StatesColors[row.state],
    type: 'chip',
    sizes: { xs: 2 }
},
{
    field: 'created',
    header: 'Creado',
    type: 'date',
    sizes: { xs: 2 }
},
{
    field: 'warehouseOrigen',
    header: 'Origen',
    translate: (warehosue) => warehosue.name,
    sizes: { xs: 2 }
},
{
    field: 'warehouseDestination',
    header: 'Destino',
    translate: (warehosue) => warehosue.name,
    sizes: { xs: 2 }
}];